<template>
  <div>
    <PageMain
      ref="main"
      @reload="$emit('reload')"
      @openEditPage="(code)=> $emit('openEditPage', code)"
      :tableData="tableData"
      :loading="loading"
    >
    </PageMain>
  </div>
</template>
<script>
import PageMain from './main.vue'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { PageMain },
  data() {
    return {}
  },
}
</script>
